var _circle, _circle2, _circle3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaced(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 184,
    viewBox: "0 0 184 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 92,
    r: 92,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 92,
    r: 69,
    fill: "#38FE49",
    fillOpacity: 0.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 92,
    r: 46,
    fill: "#04FF2C",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.881 79.8799C104.444 79.3435 105.194 79.0469 105.972 79.0528C106.75 79.0587 107.495 79.3666 108.05 79.9115C108.606 80.4564 108.928 81.1957 108.948 81.9734C108.969 82.7512 108.686 83.5065 108.161 84.0799L92.2006 104.04C91.9262 104.336 91.595 104.573 91.2268 104.737C90.8585 104.902 90.4609 104.991 90.0576 104.998C89.6544 105.006 89.2537 104.932 88.8797 104.781C88.5056 104.63 88.1658 104.405 87.8806 104.12L77.2966 93.5359C77.0019 93.2613 76.7655 92.9301 76.6015 92.5621C76.4375 92.1941 76.3494 91.7968 76.3423 91.394C76.3352 90.9912 76.4093 90.5911 76.5601 90.2176C76.711 89.844 76.9356 89.5047 77.2205 89.2198C77.5054 88.9349 77.8447 88.7103 78.2182 88.5595C78.5918 88.4086 78.9919 88.3345 79.3947 88.3416C79.7975 88.3487 80.1948 88.4369 80.5628 88.6008C80.9308 88.7648 81.262 89.0012 81.5366 89.2959L89.9126 97.6679L103.805 79.9679C103.83 79.9372 103.856 79.9078 103.885 79.8799H103.881Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaced);
export default __webpack_public_path__ + "static/media/placed.4cb391be3de49c66f15822eecfa61470.svg";
export { ForwardRef as ReactComponent };